import CONSTANT from 'modules/constant';
import type {
  PaginationProps,
  ResultProps,
  DailyCheckinEventProps,
  DailyCheckinDetailProps,
} from 'modules/types';
import { API, headers } from './api';

const dailyCheckinEvent = API.injectEndpoints({
  endpoints: (builder) => ({
    getListDailyCheckinEvent: builder.mutation<PaginationProps<DailyCheckinEventProps>, FormData>({
      query: (body) => ({
        url: CONSTANT.URL_DAILY_CHECKIN_LIST,
        method: 'POST',
        headers: headers({ useContentType: false }),
        body,
        formData: true
      })
    }),
    getDailyCheckinDetail: builder.mutation<DailyCheckinDetailProps, number>({
      query: (id) => ({
        url: CONSTANT.URL_DAILY_CHECKIN_DETAIL + id,
        method: 'GET',
        headers: headers()
      })
    }),
    createDailyCheckin: builder.mutation<ResultProps, FormData>({
      query: (body) => ({
        url: CONSTANT.URL_DAILY_CHECKIN_CREATE,
        method: 'POST',
        headers: headers({ useContentType: false }),
        body,
        formData: true
      })
    }),
    updateDailyCheckin: builder.mutation<ResultProps, FormData>({
      query: (body) => ({
        url: CONSTANT.URL_DAILY_CHECKIN_CREATE,
        method: 'POST',
        headers: headers({ useContentType: false }),
        body,
        formData: true
      })
    }),
    deleteDailyCheckin: builder.mutation<ResultProps, number>({
      query: (id) => ({
        url: CONSTANT.URL_DAILY_CHECKIN_DELETE + `/${id}`,
        method: 'DELETE',
        headers: headers()
      })
    }),
    disableDailyCheckin: builder.mutation<ResultProps, number>({
      query: (id) => ({
        url: CONSTANT.URL_DAILY_CHECKIN_DISABLE + `/${id}`,
        method: 'PUT',
        headers: headers()
      })
    })
  })
})

export const {
  useGetListDailyCheckinEventMutation,
  useGetDailyCheckinDetailMutation,
  useCreateDailyCheckinMutation,
  useUpdateDailyCheckinMutation,
  useDeleteDailyCheckinMutation,
  useDisableDailyCheckinMutation
} = dailyCheckinEvent